import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = not auth'd, object = auth'd
  const [loading, setLoading] = useState(true);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
  const api = axios.create({
    baseURL: BACKEND_URL,
    withCredentials: true,
  });

  const checkAuth = async () => {
    try {
      const res = await api.get("/api/auth/me");
      setUser(res.data);
    } catch (err) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (email, password, isAdminLogin = false) => {
    const res = await api.post("/api/auth/login", { email, password, is_admin_login: isAdminLogin });
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    await api.post("/api/auth/logout");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, checkAuth, fetchUser: checkAuth, api }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
